export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 64,
  H_DESKTOP_OFFSET: 64,
};

export const USP_HEADER_HEIGHT = `40px`;

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};

export const paths = {
  home: '/',
  download: '#download-apps',
  managePlaylist: '/playlists?type=list',
  activate: '/playlists?type=activate',
  becomeReseller: '/become-reseller',
  contactUs: '/contact-us',
  faq: '/faqs',
  termsAndConditions: '/terms-and-conditions',
  privacyPolicy: '/privacy-policy',
  dashboard: '/admin/dashboard',
  devices: '/admin/devices',
  orders: '/admin/orders',
  userSettings: '/admin/settings/user-settings',
  appSettings: '/admin/settings/app-settings',
};

export const navConfig = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Manage Playlists',
    path: paths.managePlaylist,
  },
  {
    title: 'Activate',
    path: paths.activate,
  },
  {
    title: 'Contact Us',
    path: paths.contactUs,
  },
];

export const footerLinks = [
  {
    headline: 'Quick Links',
    children: [
      { name: 'Contact us', href: paths.contactUs },
      { name: 'FAQs', href: paths.faq },
      { name: 'Manage Playlists', href: paths.managePlaylist },
      { name: 'Activate', href: paths.activate },
      { name: 'Become Reseller', href: paths.becomeReseller },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Conditions', href: paths.termsAndConditions },
      { name: 'Privacy Policy', href: paths.privacyPolicy },
    ],
  },
];

export const PAYMENT_PRICING = [
  {
    tier: 1,
    price: 9.99,
    title: '1 Year',
    enabled: true,
  },
  {
    tier: 2,
    price: 14.99,
    // discount: 7.99,
    // percent: '20%',
    title: 'Lifetime',
    enabled: true,
  },
];
// ADMIN

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PAGE_OFFSET = 0;

export const DEFAULT_DEVICE_FILTERS = {
  appTypes: [],
  paidStatus: [],
  macAddress: '',
};

export const DEVICE_TABLE_HEAD = [
  { id: '_id', label: 'Device ID' },
  { id: 'mac_address', label: 'Mac Address', width: 180 },
  { id: 'expire_date', label: 'Expiration', width: 220 },
  { id: 'is_trial', label: 'Paid', width: 180 },
  { id: 'app_type', label: 'App Type', width: 150 },
  { id: 'created_time', label: 'Created At', width: 100 },
  { id: 'activated_at', label: 'Activated At', width: 100 },
  { label: 'Actions', width: 100 },
];

export const ORDER_TABLE_HEAD = [
  { id: 'mac_address', label: 'Mac Address', width: 180 },
  { id: 'payment_type', label: 'Payment Type', width: 130 },
  { id: 'app_type', label: 'App Type', width: 130 },
  { id: 'status', label: 'Status', width: 100 },
  { id: 'pay_time', label: 'Paid Time', width: 100 },
  { id: 'amount', label: 'Amount', width: 100 },
];

export const DEVICE_APP_TYPES = [
  'android',
  'roku',
  'iOS',
  'tvOS',
  'macOS',
  'samsung',
  'lg',
  'vidaa',
  'zeasn',
  'windows',
];

export const DEVICE_PAID_STATUS = ['Paid', 'Unpaid'];

export const ORDER_STATUS = ['success', 'pending', 'failed'];

export const USPItems = [
  {
    title: 'Discount',
    content: '40% off',
    link: '/playlists?type=activate',
  },
  {
    title: 'Support',
    content: 'Multiplatform',
    link: '/#download-apps',
  },
  {
    title: 'Invite Friends',
    content: 'Get free activation',
    link: '',
  },
];

export const APP_NAME = 'xciptvsmartplayer';

export const MAXIMUM_TRANSFER_COUNT = 3;
